import { render } from "./milestone-plan-confirmation-dialog.vue?vue&type=template&id=3ebf04c1&ts=true"
import script from "./milestone-plan-confirmation-dialog.vue?vue&type=script&lang=ts"
export * from "./milestone-plan-confirmation-dialog.vue?vue&type=script&lang=ts"

import "./milestone-plan-confirmation-dialog.vue?vue&type=style&index=0&id=3ebf04c1&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__